<template>
  <page-component style="position: relative" class="agent-data-page">
    <!-- eslint-disable -->
    <template #content>
      <AddNewRequestBtn />
      <v-form class="mt-5 cs-form" :disabled="agentFormDisabled">
        <v-card flat>
          <v-layout row wrap class="userProfile__container cs-form__body">
            <!-- Product selection + progress -->
            <v-col cols="12" class="pa-0">
              <div class="cs-form__toolbar-row">
                <div class="cs-form__toolbar-half cs-form__toolbar-half--product">
                  <div class="cs-form__toolbar-question">اختر نوع المنتج ؟</div>
                  <div class="cs-form__toolbar-controls">
                    <div class="input__group cs-form__product-select" id="req_product_type">
                      <div>نوع المنتج </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete
                        :items="productTypeItems"
                        hide-details
                        v-model="productTypeModel"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1 cs-field__value"
                        outlined
                        dense
                        flat
                        :disabled="agentFormDisabled"
                      />
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>

                    <span v-if="agent.current_user_has_selected_product_type" class="cs-form__product-badge">{{ productTypeLabel || requestTypeLabel }}</span>
                  
                  </div>
                </div>
                <div class="cs-form__toolbar-half cs-form__toolbar-half--progress">
                  <div class="cs-form__toolbar-left">
                    <span class="cs-progress__badge">{{ completedDataPercent }}%</span>
                    <div class="cs-progress__track">
                      <div class="cs-progress__fill" :style="{ width: completedDataPercent + '%' }"></div>
                      <span class="cs-progress__thumb" :style="{ right: completedDataPercent + '%' }"></span>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="pa-0">
              <div class="cs-form__main-title">بيانات العميل</div>
            </v-col>

            <!-- البيانات الشخصية -->
            <v-col cols="12" class="pa-0">
              <div class="cs-form__section">
                <div class="cs-form__section-title">البيانات الشخصية</div>
                <div class="cs-form__fields-row cs-form__fields-row--4">
                  <div class="cs-form__field-col">
                    <div class="input__group" id="customerName">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt=""
                          @click="show_Field_log('customerName')" />
                        اسم العميل
                      </div>
                      <div class="horizontal__line"></div>
                      <div class="cs-field__value">
                        <v-text-field
                          type="text"
                          hide-details
                          dense
                          flat
                          solo
                          v-model="agent.customer.name"
                          ref="customerName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div class="input__group input__group--mobile" id="mobile">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt=""
                          @click="show_Field_log('mobile')" />
                        جوال العميل
                      </div>
                      <div class="horizontal__line"></div>
                      <div class="cs-field__value">
                        <v-text-field
                          type="text"
                          hide-details
                          dense
                          flat
                          solo
                          v-model="agent.customer.mobile"
                          v-numericOnly
                          :disabled="forMorPur"
                        />
                        <div class="cs-mobile-actions">
                          <img src="@/assets/icons/add-new.svg" alt="" @click="showNums = !showNums" />
                          <img @click="secondNumber = !secondNumber" src="@/assets/add-num.png" alt="" />
                          <a :href="'https://wa.me/966' + agent.customer.mobile" target="_blank" rel="noopener">
                            <img src="@/assets/whatsapp.png" alt="" height="18" width="18" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div class="input__group" id="sex">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt=""
                          @click="show_Field_log('sex')" />
                        الجنس
                      </div>
                      <div class="horizontal__line"></div>
                      <div class="cs-field__value">
                        <v-autocomplete
                          :items="['أنثي', 'ذكر']"
                          v-model="sex"
                          hide-details
                          dense
                          flat
                          solo
                        />
                      </div>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div class="input__group" id="nationality_id">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt=""
                          @click="show_Field_log('nationality_id')" />
                        الجنسية
                      </div>
                      <div class="horizontal__line"></div>
                      <div class="cs-field__value">
                        <v-autocomplete
                          :items="['غير سعودي', 'سعودي']"
                          v-model="selectedNationality"
                          hide-details
                          dense
                          flat
                          solo
                        />
                      </div>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                </div>
                <div class="cs-form__fields-row cs-form__fields-row--4 mt-2">
                  <div class="cs-form__field-col">
                    <div class="input__group" id="agent_identity_number">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt=""
                          @click="show_Field_log('agent_identity_number')" />
                        رقم الهويه
                      </div>
                      <div class="horizontal__line"></div>
                      <div class="cs-field__value">
                        <v-text-field
                          type="text"
                          hide-details
                          dense
                          flat
                          solo
                          v-model="agent.agent_identity_number"
                          v-numericOnly
                          maxlength="10"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="cs-form__divider" />
            </v-col>

            <!-- Dynamic fields based on product type -->
            <!-- Commercial Product Type -->
            <v-col cols="12" v-if="isCommercialProduct" class="pa-0">
              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العقار</div>
                <div class="cs-form__fields-row cs-form__fields-row--2">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="realCity">
                      <div style="display:flex; align-items:center; gap:6px">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                        المدينة
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                        item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('entity_type')" />
                        نوع الكيان
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.entity_types || []" hide-details
                        v-model="agent.customer.entity_type_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العمل والراتب</div>
                <div class="cs-form__fields-row">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="annual_income">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('annual_income')" />
                        الدخل السنوي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.funding.annual_income" class="mr-1" outlined
                        dense v-numericOnly />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات اضافية</div>
                <div class="cs-form__radio-row">
                  <div class="cs-form__radio-inline">
                    <span class="cs-form__radio-label">
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-left: 5px" @click="show_Field_log('commercial_activity_age')" />
                      عمر النشاط
                    </span>
                    <v-radio-group
                      v-model="agent.funding.commercial_activity_age"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                      <v-radio label="أقل من سنة" value="under_one_year" />
                      <v-radio label="أكثر من سنة" value="over_one_year" />
                    </v-radio-group>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('has_revenues')" />
                        لديه ايرادات
                      </span>
                      <v-radio-group
                        v-model="agent.funding.has_revenues"
                        row dense hide-details
                        class="ma-0 pt-0 mt-0 cs-form__radio-group"
                        color="#451646"
                      >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.funding.has_revenues === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group" id="revenue_type_id">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('revenue_type_id')" />
                          نوع الايراد
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.revenue_types || []" hide-details
                          v-model="agent.funding.revenue_type_id" item-text="value" item-value="id"
                          style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('has_property')" />
                        لديه عقار
                      </span>
                      <v-radio-group
                        v-model="agent.real_estate.has_property"
                        row dense hide-details
                        class="ma-0 pt-0 mt-0 cs-form__radio-group"
                        color="#451646"
                      >
                        <v-radio label="نعم" :value="1" />
                        <v-radio label="لا" :value="0" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.real_estate.has_property === 1" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('realType')" />
                          نوع العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.estate_types || []" hide-details
                          v-model="agent.real_estate.type" item-text="value" item-value="id"
                          style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__radio-inline">
                    <span class="cs-form__radio-label">
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-left: 5px" @click="show_Field_log('has_obligations')" />
                      هل لديه التزامات
                    </span>
                    <v-radio-group
                      v-model="agent.customer.has_obligations"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                      <v-radio label="نعم" value="yes" />
                      <v-radio label="لا" value="no" />
                    </v-radio-group>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('distress')" />
                        هل لديه تعثرات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_financial_distress"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.customer.has_financial_distress === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('financial_distress_value')" />
                          مبلغ التعثر
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.customer.financial_distress_value"
                          class="mr-1" outlined dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="agent.customer.has_obligations === 'yes'" class="mt-3">
                  <ObligationsTable v-model="obligations" :headers="obligationHeaders" />
                </div>
              </div>
              <hr class="cs-form__divider" />
            </v-col>

            <!-- Personal Product Type -->
            <v-col cols="12" v-if="isPersonalProduct" class="pa-0">
              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العمل والراتب</div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('work')" />
                        جهة العمل
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.works_list" hide-details v-model="agent.customer.work"
                        item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary')" />
                        صافي الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col" v-if="agent.customer.work != 3">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('basic_salary')" />
                        الراتب الأساسي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.basic_salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="salary_sources">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary_source')" />
                        جهة نزول الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.salary_sources" item-text="value" item-value="id" hide-details
                        v-model="agent.customer.salary_id" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                </div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col cs-form__field-col--date">
                    <new-date-fields
                      cs-design
                      label="تاريخ الميلاد (هجري)"
                      v-model="agent.customer.birth_date_higri"
                      @update:miladi="agent.customer.birth_date = $event"
                      :defaultHijri="agent.customer.birth_date_higri"
                    />
                  </div>
                  <div class="cs-form__field-col cs-form__field-col--date" v-if="agent.customer.work != 3">
                    <new-date-fields
                      cs-design
                      label="تاريخ التعيين (هجري)"
                      v-model="agent.customer.hiring_date"
                      @update:miladi="agent.customer.hiring_date_miladi = $event"
                      :defaultHijri="agent.customer.hiring_date"
                    />
                  </div>
                </div>
                <!-- Military / Civil sub-fields -->
                <v-row class="mt-2" v-if="agent.customer.work == 1 || agent.customer.work == 2">
                  <!-- Military fields (work == 1) -->
                  <v-col cols="12" md="6" v-if="agent.customer.work == 1">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('askaryWork')" />
                        الجهة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_works" hide-details
                        v-model="agent.customer.askary_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" v-if="agent.customer.work == 1">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('rank')" />
                        الرتبة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_ranks" hide-details
                        v-model="agent.customer.military_rank" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- Civil fields (work == 2) -->
                  <v-col cols="12" md="6" v-if="agent.customer.work == 2">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('madanyWork')" />
                        الجهة المدنية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.madany_works" hide-details
                        v-model="agent.customer.madany_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" v-if="agent.customer.work == 2">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('jobTitle')" />
                        المنصب الوظيفي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.job_title" class="mr-1"
                        outlined dense />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات اضافية</div>
                <div class="cs-form__radio-row">
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('has_obligations')" />
                        هل لديه التزامات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_obligations"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('distress')" />
                        هل لديه تعثرات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_financial_distress"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.customer.has_financial_distress === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('financial_distress_value')" />
                          مبلغ التعثر
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.customer.financial_distress_value"
                          class="mr-1" outlined dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="agent.customer.has_obligations === 'yes'" class="mt-3">
                  <ObligationsTable v-model="obligations" :headers="obligationHeaders" />
                </div>
              </div>
              <hr class="cs-form__divider" />
            </v-col>

            <!-- Buy Product Type -->
            <v-col cols="12" v-if="isBuyProduct || isDirectMortgageProduct" class="pa-0">
              <!-- بيانات العقار -->
              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العقار</div>
                <template v-if="isSelfBuildProduct">
                  <div class="cs-form__radio-row cs-form__property-radio">
                    <div class="cs-form__radio-inline" id="owns_land">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('owns_land')" />
                        هل تملك الأرض؟
                      </span>
                    <v-radio-group
                      v-model="agent.real_estate.owns_land"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" :value="1" />
                        <v-radio label="لا" :value="0" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__fields-row" v-if="agent.real_estate.owns_land === 1">
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group" id="realCity_self_build">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                          المدينة
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                          item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCost')" />
                          قيمة العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.real_estate.cost" class="mr-1" outlined
                          dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="isDirectMortgageProduct">
                  <div class="cs-form__fields-row cs-form__fields-row--3">
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group" id="realCity">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                          المدينة
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                          item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realType')" />
                          نوع العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.estate_types || []" hide-details
                          v-model="agent.real_estate.type" item-text="value" item-value="id"
                          style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCost')" />
                          قيمة العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.real_estate.cost" class="mr-1" outlined
                          dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="cs-form__radio-row cs-form__property-radio">
                    <div class="cs-form__radio-inline" id="has_property">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('realhasprop')" />
                        هل وجد عقار؟
                      </span>
                    <v-radio-group
                      v-model="agent.real_estate.has_property"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" :value="1" />
                        <v-radio label="لا" :value="0" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__fields-row cs-form__fields-row--3" v-if="agent.real_estate.has_property === 1">
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group" id="realCity">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                          المدينة
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                          item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realType')" />
                          نوع العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.estate_types || []" hide-details
                          v-model="agent.real_estate.type" item-text="value" item-value="id"
                          style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCost')" />
                          قيمة العقار
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.real_estate.cost" class="mr-1" outlined
                          dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__fields-row" v-else>
                    <div class="cs-form__field-col">
                      <div style="display: flex; align-items: center" class="input__group" id="realCity">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                          المدينة
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                          item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <hr class="cs-form__divider" />

              <!-- بيانات العمل والراتب -->
              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العمل والراتب</div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('work')" />
                        جهة العمل
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.works_list" hide-details v-model="agent.customer.work"
                        item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary')" />
                        صافي الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col" v-if="agent.customer.work != 3">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('basic_salary')" />
                        الراتب الأساسي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.basic_salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="salary_sources">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary_source')" />
                        جهة نزول الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.salary_sources" item-text="value" item-value="id" hide-details
                        v-model="agent.customer.salary_id" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                </div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col cs-form__field-col--date">
                    <new-date-fields
                      cs-design
                      label="تاريخ الميلاد (هجري)"
                      v-model="agent.customer.birth_date_higri"
                      @update:miladi="agent.customer.birth_date = $event"
                      :defaultHijri="agent.customer.birth_date_higri"
                    />
                  </div>
                  <div class="cs-form__field-col cs-form__field-col--date" v-if="agent.customer.work != 3">
                    <new-date-fields
                      cs-design
                      label="تاريخ التعيين (هجري)"
                      v-model="agent.customer.hiring_date"
                      @update:miladi="agent.customer.hiring_date_miladi = $event"
                      :defaultHijri="agent.customer.hiring_date"
                    />
                  </div>
                </div>
                <v-row class="mt-2" v-if="agent.customer.work == 1">
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('askaryWork')" />
                        الجهة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_works" hide-details
                        v-model="agent.customer.askary_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('rank')" />
                        الرتبة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_ranks" hide-details
                        v-model="agent.customer.military_rank" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-2" v-if="agent.customer.work == 2">
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('madanyWork')" />
                        الجهة المدنية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.madany_works" hide-details
                        v-model="agent.customer.madany_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('jobTitle')" />
                        المنصب الوظيفي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.job_title" class="mr-1"
                        outlined dense />
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-2" v-if="!isDirectMortgageProduct">
                  <v-col cols="12" md="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('funding_source')" />
                        جهة التمويل
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.funding_sources || []" hide-details
                        v-model="agent.funding.funding_source" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات اضافية</div>
                <div class="cs-form__radio-row">
                  <div class="cs-form__radio-item" v-if="!isDirectMortgageProduct">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('is_supported')" />
                        مدعوم
                      </span>
                    <v-radio-group
                      v-model="agent.customer.is_supported"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('has_obligations')" />
                        هل لديه التزامات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_obligations"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('distress')" />
                        هل لديه تعثرات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_financial_distress"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.customer.has_financial_distress === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('financial_distress_value')" />
                          مبلغ التعثر
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.customer.financial_distress_value"
                          class="mr-1" outlined dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="agent.customer.has_obligations === 'yes'" class="mt-3">
                  <ObligationsTable v-model="obligations" :headers="obligationHeaders" />
                </div>
              </div>
              <hr class="cs-form__divider" />
            </v-col>

            <!-- Mortgage Product Type -->
            <v-col cols="12" v-if="isMortgageNotDirect" class="pa-0">
              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العقار</div>
                <div class="cs-form__radio-row cs-form__property-radio mb-3">
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline" id="mortgage">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('mortgage')" />
                        العقار حر او مرهون
                      </span>
                    <v-radio-group
                      v-model="agent.real_estate.mortgage"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                          <v-radio label="حر" :value="0" />
                          <v-radio label="مرهون" :value="1" />
                        </v-radio-group>
                    </div>
                    <div v-if="Number(agent.real_estate.mortgage) === 1" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group" id="mortgage_funding_source_id">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('mortgage_funding_source_id')" />
                          لأي جهة
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete :items="$store.state.funding_sources || []" hide-details
                          v-model="agent.real_estate.mortgage_funding_source_id" item-text="value" item-value="id"
                          style="border: none !important" class="mr-1" outlined dense>
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline" id="early_payment">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('early_payment')" />
                        السداد المبكر
                      </span>
                    <v-radio-group
                      v-model="agent.funding.early_payment"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                          <v-radio label="نعم" value="yes" />
                          <v-radio label="لا" value="no" />
                        </v-radio-group>
                    </div>
                    <div v-if="agent.funding.early_payment === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('early_payment_value')" />
                          قيمة السداد
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details
                          v-model="agent.funding.early_payment_value" class="mr-1" outlined dense
                          v-numericOnly />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cs-form__fields-row">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="realCity">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('realCity')" />
                        المدينة
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.cities" hide-details v-model="agent.real_estate.city"
                        item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('realType')" />
                        نوع العقار
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.estate_types || []" hide-details
                        v-model="agent.real_estate.type" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('property_value_mortgage')" />
                        قيمة العقار
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.real_estate.cost" class="mr-1" outlined
                        dense v-numericOnly />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('property_age_mortgage')" />
                        عمر العقار
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.real_estate.age" class="mr-1" outlined
                        dense v-numericOnly />
                    </div>
                  </div>
                </div>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات العمل والراتب</div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('work')" />
                        جهة العمل
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.works_list" hide-details v-model="agent.customer.work"
                        item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary')" />
                        صافي الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col" v-if="agent.customer.work != 3">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('basic_salary')" />
                        الراتب الأساسي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.basic_salary" class="mr-1" outlined
                        dense v-numericOnly></v-text-field>
                    </div>
                  </div>
                  <div class="cs-form__field-col">
                    <div style="display: flex; align-items: center" class="input__group" id="salary_sources">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary_source')" />
                        جهة نزول الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.salary_sources" item-text="value" item-value="id" hide-details
                        v-model="agent.customer.salary_id" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </div>
                </div>
                <div class="cs-form__fields-row cs-form__fields-row--4 cs-form__work-row">
                  <div class="cs-form__field-col cs-form__field-col--date">
                    <new-date-fields
                      cs-design
                      label="تاريخ الميلاد (هجري)"
                      v-model="agent.customer.birth_date_higri"
                      @update:miladi="agent.customer.birth_date = $event"
                      :defaultHijri="agent.customer.birth_date_higri"
                    />
                  </div>
                  <div class="cs-form__field-col cs-form__field-col--date" v-if="agent.customer.work != 3">
                    <new-date-fields
                      cs-design
                      label="تاريخ التعيين (هجري)"
                      v-model="agent.customer.hiring_date"
                      @update:miladi="agent.customer.hiring_date_miladi = $event"
                      :defaultHijri="agent.customer.hiring_date"
                    />
                  </div>
                </div>
                <v-row class="mt-2" v-if="agent.customer.work == 1">
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('askaryWork')" />
                        الجهة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_works" hide-details
                        v-model="agent.customer.askary_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('rank')" />
                        الرتبة العسكرية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.military_ranks" hide-details
                        v-model="agent.customer.military_rank" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                </v-row>
                <!-- Civil fields (work == 2) -->
                <v-row class="mt-2" v-if="agent.customer.work == 2">
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('madanyWork')" />
                        الجهة المدنية
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete :items="$store.state.madany_works" hide-details
                        v-model="agent.customer.madany_id" item-text="value" item-value="id"
                        style="border: none !important" class="mr-1" outlined dense>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('jobTitle')" />
                        المنصب الوظيفي
                      </div>
                      <div class="horizontal__line"></div>
                      <v-text-field type="text" hide-details v-model="agent.customer.job_title" class="mr-1"
                        outlined dense />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <hr class="cs-form__divider" />

              <div class="cs-form__section">
                <div class="cs-form__section-title">بيانات اضافية</div>
                <div class="cs-form__radio-row">
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('has_obligations')" />
                        هل لديه التزامات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_obligations"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="cs-form__radio-item">
                    <div class="cs-form__radio-inline">
                      <span class="cs-form__radio-label">
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-left: 5px" @click="show_Field_log('distress')" />
                        هل لديه تعثرات
                      </span>
                    <v-radio-group
                      v-model="agent.customer.has_financial_distress"
                      row dense hide-details
                      class="ma-0 pt-0 mt-0 cs-form__radio-group"
                      color="#451646"
                    >
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                    <div v-if="agent.customer.has_financial_distress === 'yes'" class="cs-form__radio-extra">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('financial_distress_value')" />
                          مبلغ التعثر
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field type="text" hide-details v-model="agent.customer.financial_distress_value"
                          class="mr-1" outlined dense v-numericOnly />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="agent.customer.has_obligations === 'yes'" class="mt-3">
                  <ObligationsTable v-model="obligations" :headers="obligationHeaders" />
                </div>
              </div>
              <hr class="cs-form__divider" />
            </v-col>

            <v-col v-if="0" cols="12" lg="4" md="4" sm="6" xs="12">
              <v-card class="pa-3 position-relative userProfile__card">
                <v-col cols="12" sm="12">
                  <div style="display: flex" class="input__group" id="customerName">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('customerName')" />
                      إسم العميل
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          " v-model="agent.customer.name" ref="customerName" />
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div style="display: flex; position: relative" class="input__group" id="mobile">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('mobile')" />
                      جوال العميل
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          " v-model="agent.customer.mobile" v-numericOnly :disabled="forMorPur" />

                      <img src="@/assets/icons/add-new.svg" alt="image" @click="showNums = !showNums" style="
                            position: absolute;
                            left: 65px;
                            top: 9px;
                            width: 16px;
                            height: 25px;
                            z-index: 1;
                          " />
                      <img style="
                            cursor: pointer;
                            position: absolute;
                            left: 40px;
                            top: 10px;
                            z-index: 1;
                          " @click="secondNumber = !secondNumber" src="@/assets/add-num.png" alt="" />

                      <a :href="'https://wa.me/966' + agent.customer.mobile" style="text-decoration: none"
                        target="_blank">
                        <img style="
                              cursor: pointer;
                              position: absolute;
                              left: 10px;
                              top: 15px;
                              z-index: 1;
                            " src="@/assets/whatsapp.png" alt="" height="20px" width="20px" />
                      </a>

                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="12" v-if="0">
                  <div style="display: flex; position: relative" class="input__group" id="age">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('age')" />
                      العمر
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          " v-model="agent.customer.age" v-numericOnly />
                    </div>
                  </div>
                </v-col>

                <!--<v-col cols="12" sm="12">
                    <div style="display: flex; position: relative" class="input__group" id="salary">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('salary')"
                        />
                        صافي الراتب
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.customer.salary"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>
  
                  <v-col cols="12" sm="12">
                    <div style="display: flex; position: relative" class="input__group" id="basic_salary">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('basic_salary')"
                        />
                        الراتب الأساسي
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.customer.basic_salary"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>-->

                <v-col cols="12" sm="12">
                  <div style="display: flex; align-items: center" class="input__group" id="sex">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('sex')" />
                      الجنس
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="['أنثي', 'ذكر']" v-model="sex" style="margin-top: 15px" outlined dense>
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-bind="attrs" v-on="on">
                          <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div style="display: flex; align-items: center" class="input__group" id="nationality_id">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('nationality_id')" />
                      الجنسية
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="['غير سعودي', 'سعودي']" v-model="selectedNationality"
                      style="margin-top: 15px" outlined dense>
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-bind="attrs" v-on="on">
                          <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

              </v-card>
            </v-col>
            <v-col v-if="0" cols="12" lg="4" md="4" sm="6" xs="12">
              <v-card class="pa-3 position-relative userProfile__card">
                <v-col cols="12" sm="12">
                  <div style="display: flex" class="input__group" id="agent_identity_number">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('agent_identity_number')" />
                      رقم الهويه
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                          background-color: #fbfbfb;
                          border-right: #fbfbfb;
                          margin-top: -20px;
                        " v-model="agent.agent_identity_number" v-numericOnly maxlength="10" />
                    </div>
                  </div>
                </v-col>

                <!--<v-col cols="12" sm="12" v-if="!chowHigriDate">
                    <div style="display: flex; align-items: center" class="input__group" id="birth_date">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('birth_hijri')"
                        />
                        تاريخ الميلاد
                      </div>
                      <div class="horizontal__line"></div>
  
                      <v-text-field
                        type="date"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.customer.birth_date"
                        class="mr-1"
                        dense
                        append-icon
                      >
                        <template v-slot:append>
                          <svg
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px; cursor: pointer"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
  
                          <div class="horizontal__line" style="height: 47px"></div>
                        </template>
                      </v-text-field>
  
                      <v-text-field
                        type="text"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.customer.birth_date_higri"
                        class="mr-1"
                        placeholder="هجري"
                        dense
                        append-icon
                        @click="showHiringBirthDate = !showHiringBirthDate"
                      >
                        <template v-slot:append>
                          <svg
                            @click="showHiringBirthDate = !showHiringBirthDate"
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                      <v-hijri-date-picker
                        @change="showHiringBirthDate = false"
                        v-if="showHiringBirthDate"
                        style="position: absolute; z-index: 1000"
                        v-model="agent.customer.birth_date_higri"
                        locale="ar"
                      />
                    </div>
                  </v-col>
  
                  <v-col cols="12" sm="12" v-if="chowHigriDate">
                    <div style="display: flex; align-items: center" class="input__group" id="birth_hijri">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('birth_hijri')"
                        />
                        تاريخ الميلاد (هجري)
                      </div>
                      <div class="horizontal__line"></div>
  
                      <v-text-field
                        type="text"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.customer.birth_date_higri"
                        class="mr-1"
                        dense
                        append-icon
                            @click="showHiringBirthDate = !showHiringBirthDate"
                      >
                        <template v-slot:append>
                          <svg
                            @click="showHiringBirthDate = !showHiringBirthDate"
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px; cursor: pointer"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
                          <img
                            src="@/assets/icons/alternative.svg"
                            alt="img"
                            style="margin-right: 10px; cursor: pointer"
                            @click="chowHigriDate = !chowHigriDate"
                          />
                        </template>
                      </v-text-field>
                      <v-hijri-date-picker
                        @change="showHiringBirthDate = false"
                        v-if="showHiringBirthDate"
                        style="position: absolute; z-index: 1000"
                        v-model="agent.customer.birth_date_higri"
                        locale="ar"
                      />
                    </div>
                  </v-col>
  
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="hiring_date">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('joint_hiring_date')"
                        />
                        تاريخ التعيين
                      </div>
                      <div class="horizontal__line"></div>
  
                      <v-text-field
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.customer.hiring_date"
                        class="mr-1"
                        dense
                        append-icon
                      >
                        <template v-slot:append>
                          <svg
                            @click="showHiringDate = !showHiringDate"
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                      <v-hijri-date-picker
                        @change="showHiringDate = false"
                        v-if="showHiringDate"
                        style="position: absolute; z-index: 1000"
                        v-model="agent.customer.hiring_date"
                        locale="ar"
                      />
                    </div>
                  </v-col>
  
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="work">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('work')"
                        />
                        جهة العمل
                      </div>
                      <div class="horizontal__line"></div>
  
                      <v-autocomplete
                        :items="$store.state.works_list"
                        hide-details
                        v-model="agent.customer.work"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>-->

                <v-col cols="12" sm="12" v-if="agent.customer.work == 1 && false">
                  <div style="display: flex; align-items: center" class="input__group" id="military_rank">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('rank')" />
                      الرتبة العسكرية
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="$store.state.military_ranks" hide-details
                      v-model="agent.customer.military_rank" item-text="value" item-value="id"
                      style="border: none !important" class="mr-1" outlined dense>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <v-col cols="12" sm="12" v-if="agent.customer.work == 2">
                  <div style="display: flex; align-items: center" class="input__group" id="madany_id">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('madanyWork')" />
                      الجهة
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="$store.state.madany_works" hide-details v-model="agent.customer.madany_id"
                      item-text="value" item-value="id" style="border: none !important" class="mr-1" outlined dense>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <v-col cols="12" sm="12" v-if="agent.customer.work == 2">
                  <div style="display: flex; position: relative" class="input__group" id="job_title">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('jobTitle')" />
                      المنصب الوظيفي
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          " v-model="agent.customer.job_title" />
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="12" v-if="showSalarySource">
                  <div style="display: flex; align-items: center" class="input__group" id="salary_sources">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('salary_source')" />
                      جهة نزول المرتب
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="$store.state.salary_sources" item-text="value" item-value="id" hide-details
                      v-model="agent.customer.salary_id" class="mr-1" outlined dense>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div style="display: flex; align-items: center" class="input__group" id="you_have">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('you_have')" />
                      لديه
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete :items="['شركة', 'مؤسسة', 'فرد']" v-model="selectedYouHave" style="margin-top: 15px"
                      outlined dense>
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-bind="attrs" v-on="on">
                          <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div style="display: flex; align-items: center" class="input__group">
                    <div>
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('source_of_income')" />
                      مصدر دخلك
                    </div>
                    <div class="horizontal__line"></div>

                    <v-autocomplete
                      :items="['نقاط بيع', 'قوائم مالية', 'راتب فقط', 'أمتلك منشأة تجارية', 'أمتلك عقار', 'لا يوجد']"
                      v-model="selectedSourceOfIncome" style="margin-top: 15px" outlined dense>
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-bind="attrs" v-on="on">
                          <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <img src="@/assets/icons/down-arrow.svg" />
                  </div>
                </v-col>

                <!--<v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="nationality_id">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('nationality_id')"
                        />
                        الجنسية
                      </div>
                      <div class="horizontal__line"></div>
  
                      <v-autocomplete
                        :items="['غير سعودي', 'سعودي']"
                        v-model="selectedNationality"
                        style="margin-top: 15px"
                        outlined
                        dense
                      >
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-title
                              :id="attrs['aria-labelledby']"
                              v-text="item"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>-->

              </v-card>
            </v-col>
            <v-col v-if="0" cols="12" lg="4" md="4" sm="6" xs="12">
              <v-card class="px-3 position-relative userProfile__card">
                <div class="switch__container">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('support')" />
                    هل هو مدعوم
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.is_supported">
                      <v-radio label="نعم" value="yes" />
                      <v-radio label="لا" value="no" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                <div class="switch__container">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('without_transfer_salary')" />
                    بدون تحويل الراتب
                  </div>
                  <div>
                    <v-radio-group v-model="agent.customer.without_transfer_salary" row>
                      <v-radio label="نعم" :value="1" />
                      <v-radio label="لا" :value="0" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" v-show="0" />

                <div class="switch__container" v-show="0">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('add_support_installment_to_salary')" />
                    إضافة قسط الدعم إلى الراتب
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.add_support_installment_to_salary">
                      <v-radio label="نعم" :value="1" />
                      <v-radio label="لا" :value="0" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" v-show="0" />

                <div class="switch__container" v-show="0">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('guarantees')" />
                    الضمانات
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.guarantees">
                      <v-radio label="نعم" :value="1" />
                      <v-radio label="لا" :value="0" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                <div class="switch__container">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('has_obligations')" />
                    هل لديه التزامات
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.has_obligations">
                      <v-radio label="نعم" value="yes" />
                      <v-radio label="لا" value="no" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                <div class="switch__container">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('distress')" />
                    هل لديه تعثرات
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.has_financial_distress">
                      <v-radio label="نعم" value="yes" />
                      <v-radio label="لا" value="no" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                <div class="switch__container">
                  <div>
                    <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                      style="margin-left: 5px" @click="show_Field_log('have_salary')" />
                    هل لديك راتب
                  </div>
                  <div>
                      <v-radio-group class="cs-radio-group" dense row color="#451646" v-model="agent.customer.have_salary">
                      <v-radio label="نعم" value="yes" />
                      <v-radio label="لا" value="no" />
                    </v-radio-group>
                    </div>
                </div>
                <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />


                <v-col cols="12" sm="12" v-if="agent.customer.has_financial_distress === 'yes'">
                  <div style="display: flex; position: relative" class="input__group">
                    <div style="display: flex; align-items: center">
                      <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                        style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('financial_distress_value')" />
                      قيمة التعثرات
                    </div>
                    <div class="horizontal__line"></div>
                    <div>
                      <v-text-field type="text" class="form-control" style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          " v-model="agent.customer.financial_distress_value" v-numericOnly />
                    </div>
                  </div>
                </v-col>
              </v-card>
            </v-col>
          </v-layout>
        </v-card>
      </v-form>
        <v-sheet class="px-3 pb-3 pt-5">
        <v-form :disabled="agentFormDisabledJoint">
          <!-- بيانات المتضامن -->
          <div
            @click="openInformationJoint = !openInformationJoint"
            class="d-flex align-center justify-center py-3"
            style="
              font: 16px;
              border-radius: 4px;
              color: white;
              background-color: #451646;
              cursor: pointer;
              padding-bottom: 10px !important;
            "
          >
            بيانات المتضامن
          </div>

          <v-card flat v-if="openInformationJoint" class="mt-3">
            <v-layout
              row
              wrap
              style="background-color: #f3f5f7"
              class="userProfile__container"
            >
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  <v-col cols="12" sm="12">
                    <div style="display: flex" class="input__group">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointName')"
                        />
                        اسم المتضامن
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.name"
                          ref="customerName"
                        />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <div style="display: flex" class="input__group">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointMobile')"
                        />
                        جوال المتضامن
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.mobile"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <div style="display: flex" class="input__group">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointSalary')"
                        />
                        راتب المتضامن
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.salary"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="!showHigriDateJoint">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('birth_hijri')"
                        />
                        تاريخ الميلاد (ميلادي)
                      </div>
                      <div class="horizontal__line"></div>

                      <v-text-field
                        type="date"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.joint.birth_date"
                        class="mr-1"
                        dense
                        append-icon
                      >
                        <template v-slot:append>
                          <svg
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>

                          <img
                            src="@/assets/icons/alternative.svg"
                            alt="img"
                            style="margin-right: 10px; cursor: pointer"
                            @click="showHigriDateJoint = !showHigriDateJoint"
                          />
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="showHigriDateJoint">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div style="display: flex; align-items: center">
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('birth_hijri')"
                        />
                        تاريخ الميلاد (هجري)
                      </div>
                      <div class="horizontal__line"></div>

                      <v-text-field
                        type="text"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.joint.birth_date_higri"
                        class="mr-1"
                            @click="showHiringBirthDateJoint = !showHiringBirthDateJoint"
                        dense
                        append-icon
                      >
                        <template v-slot:append>
                          <svg
                            @click="showHiringBirthDateJoint = !showHiringBirthDateJoint"
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
                          <img
                            src="@/assets/icons/alternative.svg"
                            alt="img"
                            style="margin-right: 10px; cursor: pointer"
                            @click="showHigriDateJoint = !showHigriDateJoint"
                          />
                        </template>
                      </v-text-field>
                      <v-hijri-date-picker
                        @change="showHiringBirthDateJoint = false"
                        v-if="showHiringBirthDateJoint"
                        style="position: absolute; z-index: 1000"
                        v-model="agent.joint.birth_date_higri"
                        locale="ar"
                      />
                    </div>
                  </v-col>
                </v-card>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  <v-col cols="12" sm="12">
                    <div style="display: flex" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointage')"
                        />
                        العمر
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.age"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointWork')"
                        />
                        جهة العمل
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.works_list"
                        hide-details
                        v-model="agent.joint.work"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="agent.joint.work == 1">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointaskaryWork')"
                        />
                        الجهة
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.military_works"
                        hide-details
                        v-model="agent.joint.askary_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="agent.joint.work == 1">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointRank')"
                        />
                        الرتبة العسكرية
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.military_ranks"
                        hide-details
                        v-model="agent.joint.military_rank"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="agent.joint.work == 2">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointmadanyWork')"
                        />
                        الجهة
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.madany_works"
                        hide-details
                        v-model="agent.joint.madany_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" v-if="agent.joint.work == 2">
                    <div style="display: flex; position: relative" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointJobTitle')"
                        />
                        المنصب الوظيفي
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.job_title"
                        />
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointsalary_source')"
                        />
                        جهة نزول المرتب
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.salary_sources"
                        hide-details
                        v-model="agent.joint.salary_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointfunding_source')"
                        />
                        جهة التمويل
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.funding_sources"
                        hide-details
                        v-model="agent.joint.funding_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                </v-card>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('joint_hiring_date')"
                        />
                        تاريخ التعيين
                      </div>
                      <div class="horizontal__line"></div>

                      <v-text-field
                        type="date"
                        style="margin-bottom: 5px"
                        hide-details
                        v-model="agent.joint.hiring_date"
                        class="mr-1"
                        dense
                        append-icon
                      >
                        <template v-slot:append>
                          <svg
                            id="calendar"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.396"
                            height="16.989"
                            viewBox="0 0 17.396 16.989"
                            style="margin-top: 15px"
                          >
                            <path
                              id="Path_2784"
                              data-name="Path 2784"
                              d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                              transform="translate(-4.21 -7.917)"
                              fill="#6c757d"
                            />
                            <path
                              id="Path_2785"
                              data-name="Path 2785"
                              d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                              transform="translate(-4.21 -4.86)"
                              fill="#6c757d"
                            />
                          </svg>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>
                  <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                  <div class="switch__container">
                    <div>
                      <img
                        src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                        alt="image"
                        style="margin-left: 5px"
                        @click="show_Field_log('jointSupport')"
                      />
                      هل هو مدعوم
                    </div>
                    <div>
                      <v-radio-group v-model="agent.joint.is_supported" row>
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                  <div class="switch__container">
                    <div>
                      <img
                        src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                        alt="image"
                        style="margin-left: 5px"
                        @click="show_Field_log('joint_add_support_installment_to_salary')"
                      />
                      إضافة قسط الدعم إلي الراتب
                    </div>
                    <div>
                      <v-radio-group
                        v-model="agent.joint.add_support_installment_to_salary"
                        row
                      >
                        <v-radio label="نعم" value="1" />
                        <v-radio label="لا" value="0" />
                      </v-radio-group>
                    </div>
                  </div>
                  <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />

                  <div class="switch__container">
                    <div>
                      <img
                        src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                        alt="image"
                        style="margin-left: 5px"
                        @click="show_Field_log('jointObligations')"
                      />
                      هل لديه إلتزامات
                    </div>
                    <div>
                      <v-radio-group v-model="agent.joint.has_obligations" row>
                        <v-radio label="نعم" value="yes" />
                        <v-radio label="لا" value="no" />
                      </v-radio-group>
                    </div>
                  </div>
                  <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />
                  <v-col cols="12" sm="12" v-if="agent.joint.has_obligations === 'yes'">
                    <div style="display: flex" class="input__group" id="jointobligations_value">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('jointobligations_value')"
                        />
                        قيمة الإلتزامات
                      </div>
                      <div class="horizontal__line"></div>
                      <div>
                        <v-text-field
                          type="text"
                          class="form-control"
                          style="
                            background-color: #fbfbfb;
                            border-right: #fbfbfb;
                            margin-top: -20px;
                          "
                          v-model="agent.joint.obligations_value"
                          v-numericOnly
                        />
                      </div>
                    </div>
                  </v-col>
                </v-card>
              </v-col>
            </v-layout>
          </v-card>
        </v-form>
      </v-sheet>

      <!--Dialog Add Numbers-->
      <v-dialog v-model="secondNumber" max-width="540px">
        <v-card class="pl-3">
          <div class="d-flex justify-space-between align-center">
            <v-card-title> اضافة رقم هاتف</v-card-title>
            <v-icon style="cursor: pointer" @click="secondNumber = false">mdi-close</v-icon>
          </div>
          <v-card-text>
            <v-text-field hide-details class="mr-1" outlined dense v-model="secNum"
              @keydown="confirmNum.err = true"></v-text-field>
            <div class="d-flex justify-content-center">
              <v-btn class="mt-5 success white--text d-block" @click="addNumber">{{
                verifing ? "جاري التحقق ..." : "اضافة"
              }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--Dialog-->

      <!--Dialog Show Numbers-->
      <v-dialog v-model="showNums" max-width="540px">
        <v-card v-if="numbersArray.length > 0" class="pb-3 pl-3 pr-3">
          <div class="d-flex justify-space-between align-center">
            <v-card-title> ارقام الهاتف</v-card-title>
            <v-icon style="cursor: pointer" @click="showNums = false">mdi-close</v-icon>
          </div>
          <div class="d-flex justify-start align-center flex-wrap">
            <span style="
                  background: rgb(60 89 208);
                  color: white;
                  padding: 7px 9px 9px;
                  border-radius: 10px;
                  font-size: 16px;
                  margin: 10px;
                  letter-spacing: 1px;
                " v-for="(num, i) in numbersArray" :key="i">{{ num.mobile }}</span>
          </div>
        </v-card>
        <v-card v-else class="text-center pt-3">
          <v-card-text style="font-size: 17px">لم يتم اضافة ارقام هاتف حتي الان</v-card-text>
        </v-card>
      </v-dialog>
      <!--Dialog-->
    </template>
  </page-component>
</template>

<script src="dist/hijir-date-picker.js"></script>
<script>

import moment from 'moment-hijri';
// import NewDateFields from "@/components/NewDateFields";
  import Axios from "axios";
  import AddNewRequestBtn from "@/components/Charts/AddNewRequestBtn";
  import ObligationsTable from "@/components/common/ObligationsTable.vue";
  import "@/components/RequestDetails/DetailsStyle.css";
  import "@/components/RequestDetailsCustomerService/CustomerServiceForm.css";
  
  import { resolveProductTypeSelectState, applyForcedProductTypeClearing } from "@/helper/productTypeSelectHelper";

  // var moment = require("moment-hijri");
  export default {
    props: ["agent"],
    components: { AddNewRequestBtn, ObligationsTable },
    data() {
      return {
        selected_products_list: [],
        payload: {},
        model: true,
        chowHigriDate: false,
        showHigriDateJoint: false,
        openInformationJoint: false,
        workList: this.$store.state.works_list,
        searchTerm: "",
        addNewRequestDialog: false,
        date: "",
        joint_birth_date: false,
        customer_birth_date: false,
        show_joint_date: false,
        show_customer_date: false,
        showHiringDate: false,
        showHiringBirthDate: false,
        showHiringBirthDateJoint: false,
        secondNumber: false,
        showNums: false,
        secNum: "",
        numbersArray: [],
        confirmNum: {
          msg: "",
        },
        verifing: false,
        isSupported: null,
        guarantees: false,
        has_obligations: false,
        has_financial_distress: false,
        sex: "",
        nationality:"",
        selectedProductCode: null,
        obligations: [],
        obligationHeaders: [
          { text: "نوع الالتزام", value: "obligation_type_id", sortable: false },
          { text: "القسط", value: "installment", sortable: false },
          { text: "المبلغ المتبقي", value: "remaining_amount", sortable: false },
          { text: "العمليات", value: "actions", sortable: false },
        ],
      };
    },
    computed: {
      //==========================================================================================================
      productTypeSelectState() {
        return resolveProductTypeSelectState(this.agent, this.selected_products_list);
      },
      productTypeItems() {
        return this.productTypeSelectState.items;
      },
      productTypeModel: {
        get() {
          if (this.productTypeSelectState.forceEmpty && !this.agent.req_product_type) {
            return null;
          }
          return this.agent.req_product_type;
        },
        set(val) {
          this.agent.req_product_type = val;
          if (this.$store.state.request_info) {
            this.$store.state.request_info.req_product_type = val;
          }
        },
      },
      //==========================================================================================================
      // Determine product type
      isCommercialProduct() {
        return this.agent.req_product_type === 'commercial_finance' || this.agent.req_product_type === 'تجاري';
      },
      isPersonalProduct() {
        return this.agent.req_product_type === 'personal_loan' || this.agent.req_product_type === 'شخصي';
      },
      isBuyProduct() {
        return (
          this.agent.req_product_type === 'buy_property' ||
          this.agent.req_product_type === 'self_build' ||
          this.agent.req_product_type === 'شراء' ||
          this.agent.req_product_type === 'بناء ذاتي'
        );
      },
      isSelfBuildProduct() {
        return (
          this.agent.req_product_type === 'self_build' ||
          this.agent.req_product_type === 'بناء ذاتي'
        );
      },
      isMortgageProduct() {
        return (
          this.agent.req_product_type === 'mortgage' ||
          this.agent.req_product_type === 'رهن' ||
          this.agent.req_product_type === 'direct_mortgage' ||
          this.agent.req_product_type === 'رهن مباشر'
        );
      },
      isMortgageNotDirect() {
        return (
          this.agent.req_product_type === 'mortgage' ||
          this.agent.req_product_type === 'رهن'
        );
      },
      isDirectMortgageProduct() {
        return (
          this.agent.req_product_type === 'direct_mortgage' ||
          this.agent.req_product_type === 'رهن مباشر'
        );
      },
      // Determine request type based on product type
      requestTypeLabel() {
        if (this.isBuyProduct) {
          return 'شراء دفعة';
        } else if (this.isMortgageProduct) {
          return 'رهن مباشر';
        } else if (this.isCommercialProduct) {
          return 'شراء';
        } else if (this.isPersonalProduct) {
          return 'شراء';
        }
        return 'شراء دفعة';
      },
      productTypeLabel() {
        const list = this.selected_products_list || [];
        const found = list.find(
          (p) => p.id === this.agent.req_product_type || p.value === this.agent.req_product_type
        );
        return found ? found.value : this.agent.req_product_type || '';
      },
      totalRemainingAmount() {
        return this.obligations.reduce((sum, item) => {
          return sum + (parseFloat(item.remaining_amount) || 0);
        }, 0);
      },
      for_agent() {
        return (
          this.$store.state.request_info.statusReq == 0 ||
          this.$store.state.request_info.statusReq == 1 ||
          this.$store.state.request_info.statusReq == 2 ||
          this.$store.state.request_info.statusReq == 4 ||
          (this.$store.state.request_info.statusReq == 19 && this.$store.state.request_info.type == 'رهن-شراء') ||
          (localStorage["role"] && localStorage["role"] == "2") && [6, 8, 13, 21, 25].includes(this.$store.state.request_info.statusReq)
        );
      },

      agentFormDisabled() {
        const role = parseInt(localStorage.getItem("role") || "0", 10);
        if (role === 7 || localStorage.getItem("isAdmin")) {
          return false;
        }
        if (role !== 0) {
          return !this.for_agent;
        }
        if (this.agent && this.agent.can_edit_request === false) {
          return true;
        }
        return !this.for_agent;
      },

      agentFormDisabledJoint() {
        const role = parseInt(localStorage.getItem("role") || "0", 10);
        if (role === 7 || localStorage.getItem("isAdmin")) {
          return false;
        }
        if (role !== 0) {
          return !this.for_agent_joint;
        }
        if (this.agent && this.agent.can_edit_request === false) {
          return true;
        }
        return !this.for_agent_joint;
      },

      for_agent_joint() {
        return (
          this.$store.state.request_info.statusReq == 0 ||
          this.$store.state.request_info.statusReq == 1 ||
          this.$store.state.request_info.statusReq == 2 ||
          this.$store.state.request_info.statusReq == 4
        );
      },

      forMorPur() {
        return (
          this.$store.state.request_info.statusReq == 19 && this.$store.state.request_info.type == 'رهن-شراء'
        );
      },
  
      selectedNationality: {
        get() {
          if(this.agent.customer.nationality_id === 1){
            return 'سعودي';
          }else if(this.agent.customer.nationality_id === 5){
            return 'غير سعودي';
          }
          // return this.agent.customer.nationality_id === 1 ? 'Saudi' : 'Non-Saudi';
        },
        set(value) {
          if(value === 'سعودي'){
            this.agent.customer.nationality_id =1;
          }else if(value === 'غير سعودي'){
            this.agent.customer.nationality_id =5;
          }
          // this.agent.customer.nationality_id = value === 'Saudi' ? 1 : 5;
        },
      },
  
      selectedYouHave: {
        get() {
          if(this.agent.customer.you_have == "company"){
            return 'شركة';
          }else if(this.agent.customer.you_have == "institution"){
            return 'مؤسسة';
          }else if(this.agent.customer.you_have == "individual"){
            return 'فرد';
          }
        },
        set(value) {
          if(value == "شركة"){
           this.agent.customer.you_have = 'company';
          }else if(value == "مؤسسة"){
           this.agent.customer.you_have = 'institution';
          }else if(value == "فرد"){
           this.agent.customer.you_have = 'individual';
          }
        },
      },
  
      selectedSourceOfIncome: {
        get() {
          if(this.agent.customer.source_of_income == "selling_points"){
            return 'نقاط بيع';
          }else if(this.agent.customer.source_of_income == "financial_menu"){
            return 'قوائم مالية';
          }else if(this.agent.customer.source_of_income == "salary_only"){
            return 'راتب فقط';
          }else if(this.agent.customer.source_of_income == "own_commercial_establishment"){
            return 'أمتلك منشأة تجارية';
          }else if(this.agent.customer.source_of_income == "own_property"){
            return 'أمتلك عقار';
          }else if(this.agent.customer.source_of_income == "nothing"){
            return 'لا يوجد';
          }
        },
        set(value) {
          if(value == "نقاط بيع"){
           this.agent.customer.source_of_income = 'selling_points';
          }else if(value == "قوائم مالية"){
           this.agent.customer.source_of_income = 'financial_menu';
          }else if(value == 'راتب فقط'){
            this.agent.customer.source_of_income = "salary_only"
          }else if(value == 'أمتلك منشأة تجارية'){
            this.agent.customer.source_of_income = "own_commercial_establishment"
          }else if(value == 'أمتلك عقار'){
            this.agent.customer.source_of_income = "own_property";
          }else if(value == "لا يوجد"){
           this.agent.customer.source_of_income = 'nothing';
          }
        },
      },
  
      // $store.state.request_info.type == 'رهن-شراء' && $store.state.request_info.statusReq == 19

      completedDataPercent() {
        const requiredIds = [
          "customerName",
          "mobile",
          "sex",
          "nationality_id",
          "identity_number",
          "birth_date",
          "work",
          "salary_sources",
          "salary",
          "you_have",
          "company_name",
          "institution_name",
          "agent_status",
        ];

        const errors = Array.isArray(this.$store.state.arrayOfErrors)
          ? this.$store.state.arrayOfErrors
          : [];

        const missingCount = errors.filter((id) => requiredIds.includes(id)).length;
        const total = requiredIds.length;
        const completed = Math.max(0, total - missingCount);
        return total ? Math.round((completed / total) * 100) : 0;
      },
    },
    mounted() {
      if (
        this.$store.state.request_info.status === `طلب تم فتحه` &&
        !(this.$store.state.request_info.is_stared == 1) &&
        !(this.$store.state.request_info.is_followed == 1)
      ) {
        this.setBreadCrumbs([
          "الرئيسية",
          "الطلبات",
          "الطلبات المستلمه",
          this.agent.customer.name,
        ]);
      } else if (this.$store.state.request_info.status === `مؤرشف لدى استشاري المبيعات`) {
        this.setBreadCrumbs([
          "الرئيسية",
          "الطلبات",
          "الطلبات المؤرشفه",
          this.agent.customer.name,
        ]);
      } else if (
        this.$store.state.request_info.status === `في انتظار موافقة مدير المبيعات`
      ) {
        this.setBreadCrumbs([
          "الرئيسية",
          "الطلبات",
          "الطلبات المكتمله",
          this.agent.customer.name,
        ]);
      } else if (this.$store.state.request_info.is_stared == 1) {
        this.setBreadCrumbs([
          "الرئيسية",
          "الطلبات",
          "الطلبات المميزه",
          this.agent.customer.name,
        ]);
      } else if (this.$store.state.request_info.is_followed == 1) {
        this.setBreadCrumbs([
          "الرئيسية",
          "الطلبات",
          "الطلبات المتابعه",
          this.agent.customer.name,
        ]);
      } else {
        this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
      }
      // this.workList = ;
      this.$store.state.arrayOfErrors.forEach((status, index) => {
        if (status != 'possible_to_sell_to_customer_no'){
          let element = document.getElementById(status);
          if (element) {
            //   element.style.border = "2px solid #f00"; // Apply red border
            element.style.color = "#f00"; // Apply red border
          }
        }else{
          let element = document.getElementById("possible_to_sell_to_customer");
          if (element) {
            //   element.style.border = "2px solid #f00"; // Apply red border
            element.style.color = "#f00"; // Apply red border
          }
        }
      });
      // Initialize selected_products_list from store - only the four required types
      if (this.$store.state.selected_products && this.$store.state.selected_products.length > 0) {
        this.selected_products_list = this.filterProductsList(this.$store.state.selected_products);
      }
      this.applyProductTypeSelectRules();
     },
    watch: {
      "$store.state.selected_products": function (val) {
        if (val && this.selected_products_list.length == 0) {
          this.selected_products_list = this.filterProductsList(this.$store.state.selected_products);
        }
      },
      sex(val) {
        if (val == "أنثي") {
          this.agent.customer.sex = "أنثي";
        } else if (val == "ذكر") {
          this.agent.customer.sex = "ذكر";
        }
      },
  
      guarantees(val) {
        if (val) {
          this.agent.customer.guarantees = 1;
        } else {
          this.agent.customer.guarantees = 0;
        }
      },
  
      has_obligations(val) {
        if (val) {
          this.agent.customer.has_obligations = "yes";
        } else {
          this.agent.customer.has_obligations = "no";
        }
      },
  
      has_financial_distress(val) {
        if (val) {
          this.agent.customer.has_financial_distress = "yes";
        } else {
          this.agent.customer.has_financial_distress = "no";
        }
      },
      date(val) {
        this.agent.joint.birth_date_higri = val;
      },
      "$route.params": {
        handler() {
          this.$router.go(this.$router.currentRoute);
        },
        deep: true,
      },
      "agent.customer.birth_date_higri": {
        handler(val) {
          if (val) {
            this.agent.customer.birth_date = moment(val, "iYYYY/iM/iD").format("YYYY-M-D");
          }
        },
      },
      agent: {
        handler(val) {
          if (val) {
            // Update store only, avoid mutating agent to prevent infinite loop
            this.$nextTick(() => {
              if (this.$store.state.request_info !== val) {
                this.$store.state.request_info = val;
              }

              if (
                val.real_estate &&
                typeof val.real_estate.mortgage_funding_source_id === "undefined"
              ) {
                this.$set(val.real_estate, "mortgage_funding_source_id", null);
              }
              if (
                val.real_estate &&
                typeof val.real_estate.owns_land === "undefined"
              ) {
                this.$set(val.real_estate, "owns_land", null);
              }
              
              // Handle military_rank properly - convert to number if exists, otherwise keep as null/undefined
              if (val.customer && val.customer.military_rank !== null && val.customer.military_rank !== undefined && val.customer.military_rank !== '') {
                val.customer.military_rank = parseInt(val.customer.military_rank);
                // If parseInt returns NaN, set to null
                if (isNaN(val.customer.military_rank)) {
                  val.customer.military_rank = null;
                }
              }
              
              // Load obligations when agent data is loaded
              if (val.customer && val.customer.has_obligations === 'yes') {
                this.loadObligations();
              }
            });
          }
        },
        deep: false,
        immediate: true,
      },
      "agent.customer.has_obligations": {
        handler(val) {
          if (val === 'yes') {
            if (this.obligations.length === 0) {
              this.addObligationRow();
            }
            this.loadObligations();
          } else {
            this.obligations = [];
          }
        },
      },
      obligations: {
        handler(val) {
          this.$nextTick(() => {
            if (this.$store.state.request_info && this.$store.state.request_info.obligations !== val) {
              this.$set(this.$store.state.request_info, 'obligations', val);
            }
          });
        },
        deep: true,
      },
      "agent.real_estate.mortgage": {
        handler(val) {
          if (Number(val) !== 1 && this.agent?.real_estate) {
            this.$set(this.agent.real_estate, "mortgage_funding_source_id", null);
          }
        },
      },
      "agent.real_estate.owns_land": {
        handler(val) {
          if (
            this.isSelfBuildProduct &&
            this.agent?.real_estate &&
            val !== 1 &&
            val !== "1"
          ) {
            this.$set(this.agent.real_estate, "city", null);
            this.$set(this.agent.real_estate, "cost", "");
          }
        },
      },
    },
    methods: {
      applyProductTypeSelectRules() {
        applyForcedProductTypeClearing(this.agent, this.$store);
      },
      // Filter products list to include only the allowed types
      filterProductsList(products) {
        if (!products || !Array.isArray(products)) {
          return [];
        }
        const allowedTypes = [
          'buy_property',
          'self_build',
          'mortgage',
          'direct_mortgage',
          'commercial_finance',
          'personal_loan',
          'شراء عقار',
          'بناء ذاتي',
          'رهن عقار',
          'رهن مباشر',
          'تمويل تجاري',
          'قرض شخصي',
          'شراء',
          'رهن',
          'تجاري',
          'شخصي',
        ];
        return products.filter(product => {
          const productId = product.id || product.value;
          return allowedTypes.includes(productId);
        });
      },
      openBuyPaymentDialog() {
        // The dialog is mounted at the RequestDetails level (Customer Service uses the same base).
        this.$store.state.AgentSendPaymentDialog = true;
      },
      returnValues(val) {
        if (val == "0") {
          return false;
        } else {
          return true;
        }
      },
      async get_all_requests(page = 1) {
        this.loading = true;
        await Axios.get(
          `${this.$store.state.url}/v2/employee/Requests?type=all&page=${page}&per_page=12`,
          {
            headers: this.request_headers(),
          }
        ).then((response) => {
          this.items = response.data.payload.data;
          this.pagination = {
            limit: 10,
            count: response.data.payload.count_of_all,
          };
          this.loading = false;
        });
      },
  
      async getNumbers() {
        await Axios.get(
          `${this.$store.state.url}/agent/Request/Phones/${this.agent.id}`,
          {
            headers: this.request_headers(),
          }
        )
          .then((res) => {
            if (res.data.payload.length > 0) {
              this.numbersArray = res.data.payload;
            }
          })
          .catch((err) => console.log(err.message));
      },
      addNumber() {
        this.verifing = true;
        Axios.post(
          `${this.$store.state.url}/agent/Request/Add/Phone`,
          {
            mobile: this.secNum,
            request_id: this.agent.id,
          },
          {
            headers: this.request_headers(),
          }
        )
          .then((res) => {
            this.showPopup("success", res.data.message);
            this.secondNumber = false;
            this.getNumbers();
            this.verifing = false;
            this.secNum = "";
          })
          .catch((err) => {
            this.showPopup("error", err.response.data.message);
            this.verifing = false;
          });
      },
      addObligationRow() {
        this.obligations.push({
          id: null,
          obligation_type_id: null,
          installment: 0,
          remaining_amount: 0,
        });
      },
      removeObligationRow(index) {
        this.obligations.splice(index, 1);
      },
      async loadObligations() {
        if (this.agent.id && this.agent.customer.has_obligations === 'yes') {
          // Load obligations from agent data if available (from RequestResource)
          if (this.agent.obligations && Array.isArray(this.agent.obligations) && this.agent.obligations.length > 0) {
            this.obligations = this.agent.obligations.map(item => ({
              id: item.id,
              obligation_type_id: item.obligation_type_id,
              installment: parseFloat(item.installment) || 0,
              remaining_amount: parseFloat(item.remaining_amount) || 0,
            }));
          } else {
            // If no obligations in agent data, add empty row
            if (this.obligations.length === 0) {
              this.addObligationRow();
            }
          }
        } else {
          this.obligations = [];
        }
      },
    },
    async created() {
      if (this.agent.customer.work == "متقاعد") {
        this.agent.customer.work = 3;
      } else if (this.agent.customer.work == "عسكري") {
        this.agent.customer.work = 1;
      } else if (this.agent.customer.work == "مدني") {
        this.agent.customer.work = 2;
      } else if (this.agent.customer.work == "شبه حكومي") {
        this.agent.customer.work = 4;
      } else if (this.agent.customer.work == "قطاع خاص غير معتمد") {
        this.agent.customer.work = 5;
      } else if (this.agent.customer.work == "قطاع خاص معتمد") {
        this.agent.customer.work = 6;
      }
  
      if (this.agent.customer.sex == "female") {
        this.sex = "أنثي";
      } else if (this.agent.customer.sex == "male") {
        this.sex = "ذكر";
      }
      
      // Load obligations on component creation
      if (this.agent && this.agent.customer && this.agent.customer.has_obligations === 'yes') {
        this.$nextTick(() => {
          this.loadObligations();
        });
      }
      await this.getNumbers();
    },
  };
  </script>